/**
 * Set up menu behavior
 */

/**
 * Get dependencies
 */
import throttle from '../../util/throttle';
import onReady from '../../util/onReady';

/**
 * Set up main menu.
 */
const menuEl = document.getElementById('menu-main-wrap');
const mainMenu = (wrap) => {
	if (wrap) {
		// grab the sub elements
		const triggers = [wrap.querySelector('.js-menu-main-trigger')];
		const menu = triggers[0].nextElementSibling;

		// add the close button
		const closeToggle = document.createElement('button');
		triggers.push(closeToggle);
		closeToggle.classList.add('menu-main-close', 'js-menu-main-trigger');
		closeToggle.textContent = 'Close';
		wrap.appendChild(closeToggle);

		// start out with the nav hidden at mobile
		if (window.getComputedStyle(menu).bottom !== 'auto') {
			menu.setAttribute('aria-hidden', true);
		}

		// for each trigger
		triggers.forEach((trigger) => {
			// add accessibility
			trigger.setAttribute('aria-expanded', false);
			trigger.setAttribute('aria-controls', menu.id);

			// on click of the trigger show the menu (with accessibility)
			trigger.addEventListener('click', () => {
				const wasOpen =
					trigger.getAttribute('aria-expanded') === 'true';
				triggers.forEach((el) => {
					el.setAttribute('aria-expanded', !wasOpen);
					el.setAttribute('aria-label', wasOpen ? 'Menu' : 'Close');
					el.classList.add('ani-hack');
					setInterval(() => {
						el.classList.remove('ani-hack');
					}, 300);
				});
				menu.setAttribute('aria-hidden', wasOpen);
				document.body.classList.toggle('menu-main-active', !wasOpen);
			});
		});

		// for nav items (li) with sub menus
		menu.querySelectorAll('.menu-item-has-children').forEach((li) => {
			// cache elements
			const subMenu = li.querySelector('.sub-menu');
			const subMenuId = `${li.getAttribute('id')}-sub`;

			// make li elements tab/clickable in control of subnav
			li.setAttribute('tabindex', '0');
			li.setAttribute('role', 'button');
			li.setAttribute('aria-controls', subMenuId);
			li.setAttribute('aria-expanded', false);

			// allow "enter" keydown to activate li for accessibility
			li.addEventListener('keydown', (e) => {
				if (e.keyCode === 13 && li === document.activeElement) {
					li.click();
				}
			});

			// identify subnav as being hidden
			subMenu.setAttribute('id', subMenuId);
			subMenu.setAttribute('aria-hidden', true);

			// expand/contract sub nav
			const toggleActive = (e) => {
				e.stopPropagation();
				// if we're expanding
				const isExpanding = li.getAttribute('aria-expanded') !== 'true';
				if (isExpanding) {
					// first find and close this and all peers with sub items
					li.parentElement
						.querySelectorAll('.menu-item-has-children')
						.forEach((el) => {
							el.setAttribute('aria-expanded', false);
							el.lastElementChild.setAttribute(
								'aria-hidden',
								true
							);
						});
				}
				// expand/contract this sub nav
				li.setAttribute('aria-expanded', isExpanding);
				subMenu.setAttribute('aria-hidden', !isExpanding);
			};

			// bind the events
			li.addEventListener('click', toggleActive);
		});
	}
};

// send it!
mainMenu(menuEl);

/**
 * Set up main menu mobile/desktop styling
 */
const responsiveMenu = (wrap) => {
	if (wrap) {
		const menu = wrap.querySelector('#menu-main');
		const links = [...wrap.querySelectorAll('#menu-main > li')];
		const setMenuSize = () => {
			wrap.classList.remove('is-mobile');
			const isMobile =
				menu.offsetWidth - 10 <=
				links.reduce((a, b) => a + b.offsetWidth, 0);
			wrap.classList.toggle('is-mobile', isMobile);
		};
		onReady(() => {
			setMenuSize();
			wrap.classList.add('is-loaded');
		});
		window.addEventListener('load', setMenuSize);
		window.addEventListener('resize', throttle(setMenuSize, 300));
	}
};

// send it!
responsiveMenu(menuEl);
